import React, { forwardRef } from 'react';
import { Box, useTheme } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';
import { getWorkspaceCommandGroupSx } from './WorkflowWorkspacePrimitives';

export interface ToolbarButtonGroupProps {
  children: React.ReactNode;
  'aria-label': string;
  density?: 'compact' | 'standard';
  sx?: SxProps<Theme>;
  ref?: React.Ref<HTMLDivElement>;
}

const ToolbarButtonGroup = forwardRef<HTMLDivElement, ToolbarButtonGroupProps>(
  function ToolbarButtonGroup(
    {
      children,
      'aria-label': ariaLabel,
      density = 'standard',
      sx,
      ...rest
    },
    ref
  ) {
    const theme = useTheme();

    return (
      <Box
        ref={ref}
        role="group"
        aria-label={ariaLabel}
        sx={[
          getWorkspaceCommandGroupSx(theme, { density }),
          ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
        ]}
        {...rest}
      >
        {children}
      </Box>
    );
  }
);

ToolbarButtonGroup.displayName = 'ToolbarButtonGroup';

export default ToolbarButtonGroup;
